const fallbackBaseUrl = 'http://localhost:3001/api/v1';
const resolvedBaseUrl = import.meta.env.VITE_BASEURL || fallbackBaseUrl;
const defaultRedirectUri =
  typeof window !== 'undefined' ? `${window.location.origin}${window.location.pathname}` : '';

export const baseURL = resolvedBaseUrl;
export const env = import.meta.env.MODE;
export const rollbarAccessToken = import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN;
export const stripePublicKey = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
export const appVersion = import.meta.env.VITE_APP_VERSION || 'web';
export const serverAddress = new URL(resolvedBaseUrl);
export const isAzureMfaEnabled = import.meta.env.VITE_IS_AZURE_MFA_ENABLED;
export const aadClientId = import.meta.env.VITE_AAD_CLIENT_ID;
export const aadTenantId = import.meta.env.VITE_AAD_TENANT_ID;
export const aadEndpointHost = import.meta.env.VITE_AAD_ENDPOINT_HOST;
export const authRedirectUri = import.meta.env.VITE_AUTH_REDIRECT_URI || defaultRedirectUri;
